/**
 * <button class="group relative flex w-full items-center text-left
 *             text-neutral-800 transition [overflow-anchor:none]
 *             hover:z-[2]
 *             focus:z-[3] focus:outline-none"
 *     type="button"
 *     data-br-collapse
 *     data-br-target="#_Brands_container"
 *     {{ !$brandOpened ? 'data-br-collapse-collapsed aria-expanded="false"' : 'aria-expanded="true"' }}
 *     aria-controls="_Brands_container">
 *     Brands
 *     <span class="-mr-1 ml-auto h-3 w-5 shrink-0 rotate-0 fill-[#336dec] transition-transform duration-200 ease-in-out
 *         group-[[data-br-collapse-collapsed]]:mr-0
 *         group-[[data-br-collapse-collapsed]]:rotate-[-180deg]
 *         group-[[data-br-collapse-collapsed]]:fill-[#212529]
 *         motion-reduce:transition-none">
 *         <svg class="w-[14px]"
 *              xmlns="http://www.w3.org/2000/svg"
 *              fill="currentColor"
 *              viewBox="0 0 448 512"
 *              stroke-width="1.5"
 *              stroke="currentColor">
 *             <path d="M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z"/>
 *         </svg>
 *     </span>
 * </button>
 *
 * <div class="!visible {{ !$brandOpened ? 'hidden' : '' }}"
 *          id="_Brands_container"
 *          aria-labelledby="filterBrands">
 *      ...
 * </div>
 */

import { addListener } from "./support/utils";
class BRCollapse
{
    static collapseInstances = new Map();
    constructor(collapseElement, options={})
    {
        if (collapseElement && BRCollapse.getInstance(collapseElement) === undefined ) {

            this.brCollapse = collapseElement;
            const htmlOptions = {};
            const data = this.brCollapse.dataset;

            Object.keys(data).forEach(key => {
                if ( key.startsWith('brCollapse') ) {
                    const optionName = key.replace('brCollapse', '')
                        .replace(/^\w/, c => c.toLowerCase() );
                    htmlOptions[optionName] = data[key];
                }
            })

            // Default options
            this.options = {
                trigger: 'click', // none, hover, click
                ...htmlOptions,
                ...options
            }

            this.brView = document.querySelector( this.brCollapse.getAttribute('data-br-target') );

            this.toggle = this.toggle.bind(this);
            this.show = this.show.bind(this);
            this.hide = this.hide.bind(this);

            if (this.options.trigger !== 'none') {
                addListener(this.options.trigger, this.brCollapse, (evt) => this.toggle(evt));
            }

            BRCollapse.collapseInstances.set(collapseElement, this);
        }
    }

    toggle(evt)
    {
        let hasClass = ['hidden', '!hidden'].some(className => this.brView.classList.contains(className));
        if (hasClass) {
            this.show(evt);
        }
        else {
            this.hide(evt);
        }
    }

    show(evt)
    {
        evt.preventDefault();

        this.brView.classList.remove('hidden', '!hidden');
        this.brCollapse.setAttribute('aria-expanded', "true");
        this.brCollapse.removeAttribute('data-br-collapse-collapsed');

        this.brCollapse.dispatchEvent(new CustomEvent('br-collapse-open', { bubbles: true }));
    }

    hide(evt)
    {
        evt.preventDefault();

        this.brView.classList.add('!hidden');
        this.brCollapse.setAttribute('aria-expanded', "false");
        this.brCollapse.setAttribute('data-br-collapse-collapsed', '');

        this.brCollapse.dispatchEvent(new CustomEvent('br-collapse-closed', { bubbles: true }));
    }

    static initAll(parentElement)
    {
        let container = parentElement || document;
        container.querySelectorAll('[data-br-collapse]').forEach(collapseElement => {
            if (!BRCollapse.collapseInstances.has(collapseElement)) {
                new BRCollapse(collapseElement);
            }
        });
    }

    // Static method to access a widget instance from a DOM element
    static getInstance(collapseElement) {
        return BRCollapse.collapseInstances.get(collapseElement);
    }
}

export default BRCollapse;